import { render, staticRenderFns } from "./ScheduleChildVisitation.vue?vue&type=template&id=27060bdf"
import script from "./ScheduleChildVisitation.vue?vue&type=script&lang=js"
export * from "./ScheduleChildVisitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports